export const SET_USERAGENT = 'SET_USERAGENT';
export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_USERDETAIL = "SET_USERDETAIL";
export const SET_USERTENANT= "SET_USERTENANT";
export const SET_USER_IDENTITY= "SET_USER_IDENTITY";
